/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Foreign_Key_ViolationInputs */

const en_error_foreign_key_violation = /** @type {(inputs: Error_Foreign_Key_ViolationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A linked record is missing or still in use.`)
};

/**
* | output |
* | --- |
* | "A linked record is missing or still in use." |
*
* @param {Error_Foreign_Key_ViolationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_foreign_key_violation = /** @type {((inputs?: Error_Foreign_Key_ViolationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Foreign_Key_ViolationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_foreign_key_violation(inputs)
});